<template>
    <div :class="`m-3 wrapper wrapper--border wrapper--${table_style}`">
    <Loading v-if="loading" />
        <div>
            <h4 class="text-center">Voertuigenlijst - {{ bu }}</h4>
            <Tabs v-if="!loading">
                <Tab v-for="(status, key) in vehicle_lister" :key=key :title=key>
                    <div class="flex center p-2">
                        <table :class="`table__border--${table_style}`">
                            <thead :class="`table__head--${table_style}`">
                                <th>Foto</th>
                                <th>Item</th>
                                <th>KM stand</th>
                                <th>Inkoper</th>
                                <th>Verkoper</th>
                                <th>Factuur</th>
                                <th>Netto</th>
                                <th>Inkoop</th>
                                <th>Vraagprijs</th>
                                <th>Stadagen</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item, key) in status" :key="key" :class="`table__row--color`">
                                <td>
                                    <img :src="`https://apps.kleyn.com:1919/prod/public/data/mainimage/${item.nummer}/thumb`" />
                                </td>
                                <td>
                                    <ImageHover :itemnummer="item.nummer" :bu="item.bu" />
                                    {{ item.soortnaam }}<br />
                                    {{ item.opbouwnaam }}<br />
                                    {{ item.merknaam }}<br />
                                    {{ item.typenaam }}<br />
                                    {{ item.regjaar }}
                                </td>
                                <td>{{ item.kmstand }}</td>
                                <td>{{ item.inkopernaam }}</td>
                                <td>{{ item.verkopernaam }}</td>
                                <td>€ {{ item.factuurprijs }}</td>
                                <td>€ {{ item.nettoprijs }}</td>
                                <td>€ {{ item.inkoopprijs }}</td>
                                <td>€ {{ item.vraagprijs }}</td>
                                <td class="table__data--right">{{ item.stadagen }}</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Tab>
            </Tabs>
        </div>
    </div>
</template>
<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import Tab from "@/components/Tabs/Tab.vue";
import Loading from "@/components/Loading.vue";
import request from "@/functions/request.js";
import ImageHover from "@/components/ImageHover"

export default {
    props: ["bu"],
    components: {Tab, Tabs, Loading, ImageHover},
    data: () => ({
        vehicle_lister: null,
        loading: true,
        table_style: 210
    }),
    created() {
        this.getData(this.bu)
        console.log(this.bu)
    },
    methods: {
        getData(bu) {
            request(`vehicle-lister/${bu}`, "GET").then(({vehicle_lister}) => {
                this.vehicle_lister = vehicle_lister;
                this.loading = false;
            })
        }
    }

}
</script>